
export const ErrorMessage = {
	DefaultMessage: 'Something went wrong'
};

export const SuccessMessage = {
	Confirm_Question: 'Delete {0}?'
};

export const TooltipMessage = {
	Edit: 'Edit',
	View: 'View',
	Delete: 'Delete',
	UpdateStatus: 'Update Status',
	PermissionDenied: 'Permission denied'
};